import { useEffect, useState } from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

const Move = ({ m, up }) => (
  <li data-testid={`movers-${up ? "riser" : "faller"}-${m.slug}`} className="flex items-baseline justify-between gap-4 py-1.5 border-b border-[#FAF7F2]/10 last:border-0">
    <span><span className="font-display text-lg">{m.town}</span> <span className="text-xs text-[#FAF7F2]/60">{m.region}, {m.country}</span></span>
    <span className={`font-mono-accent text-sm ${up ? "text-[#9ED9B5]" : "text-[#F2A7A0]"}`}>{up ? "+" : ""}{m.change}%</span>
  </li>
);

export const MoversBanner = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/market/movers").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || (!d.risers.length && !d.fallers.length)) return null;
  const Col = ({ title, icon: Icon, list, up }) => (
    <div>
      <p className="eyebrow mb-2 flex items-center gap-2 text-[#C59B27]"><Icon className="w-4 h-4" />{title}</p>
      {list.length ? <ul>{list.map((m) => <Move key={m.slug} m={m} up={up} />)}</ul> : <p className="text-sm text-[#FAF7F2]/60">None this {d.mode === "month" ? "month" : "year"}.</p>}
    </div>
  );
  return (
    <section data-testid="movers-banner" className="rise bg-[#1C181D] text-[#FAF7F2] p-6 sm:p-8 grid md:grid-cols-[1fr_1.2fr_1.2fr] gap-8">
      <div>
        <p className="eyebrow text-[#FAF7F2]/60">Biggest movers</p>
        <h2 className="font-display text-3xl mt-1" data-testid="movers-label">{d.mode === "month" ? d.label : `Recorded sales, ${d.label}`}</h2>
        <p className="text-xs text-[#FAF7F2]/60 mt-3">Based on {d.basis}.{d.mode === "year" ? " Monthly movers start once there are two months of asking-price data." : ""}</p>
      </div>
      <Col title="Rising" icon={TrendingUp} list={d.risers} up />
      <Col title="Falling" icon={TrendingDown} list={d.fallers} />
    </section>
  );
};
